"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFactCompletionSync = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
const react_redux_1 = require("react-redux");
const TaskCompletenessContext_1 = require("../../context/TaskCompletenessContext");
const helpers_1 = require("../../entities/fact/helpers");
const validationListener_1 = require("./validationListener");
const taskVisit_1 = require("./taskVisit");
const merlin_hooks_1 = require("@travelnest/merlin-hooks");
const taskDiff_1 = require("../../util/taskDiff");
const useFactCompletionSync = (syncFacts = true) => {
    const { propertyId, customerId, entityActions } = react_1.default.useContext(__1.AppContext);
    const { dispatch } = (0, react_redux_1.useStore)();
    const { state: taskCompletenessState } = react_1.default.useContext(TaskCompletenessContext_1.TaskCompletenessContext);
    const previousCompletenessState = (0, merlin_hooks_1.usePrevious)(taskCompletenessState);
    const debouncedFactSync = (0, merlin_hooks_1.useDebouncedCallback)((property, customer) => __awaiter(void 0, void 0, void 0, function* () {
        yield Promise.all([
            dispatch(entityActions.facts.upsertForProperty(propertyId, property)),
            dispatch(entityActions.facts.upsertForAccount(customerId, customer))
        ]);
    }), 500);
    react_1.default.useEffect(() => {
        if (!syncFacts)
            return;
        if ((0, taskDiff_1.taskStatesDifferent)(taskCompletenessState, previousCompletenessState)) {
            const { property, customer } = (0, helpers_1.toFactEntities)(propertyId, customerId, taskCompletenessState);
            debouncedFactSync(property, customer);
        }
    }, [taskCompletenessState]);
};
exports.useFactCompletionSync = useFactCompletionSync;
const CompletionSync = ({ syncFacts }) => {
    (0, exports.useFactCompletionSync)(syncFacts);
    (0, taskVisit_1.useVisitTaskPageUpdate)();
    (0, validationListener_1.useValidationChangeTaskUpdate)();
    // Allows component to go into tree
    return null;
};
exports.default = CompletionSync;
//# sourceMappingURL=index.js.map